<template>
  <div class="openlist-container tinylist-container">
    <transition name="fade">
      <div class="openlist-items tinylist-items" v-show="transactions.length">
        <div class="row openlist-show-titlerow">
          <div class="col-xs-12">{{ DateTime.fromSeconds(Number(selectedShow.start_ts), { zone: timezone }).toFormat(dateFormat + " '" + _('at') + "' " + timeFormat) }}: {{ selectedShow.product_name }} ({{ selectedShow.resource_name }})</div>
        </div>
        <transaction-item v-for="(transaction, index) in transactions" :baseDomain="baseDomain" :key="transaction.id" :index="index" :transaction="transaction" v-on:transactionClicked="openTransaction(transaction)" v-on:notesClicked="displayNotes(transaction)"></transaction-item>
      </div>
    </transition>
    <transition name="fade">
      <div class="openlist-buttons buttons text-right" v-show="transactions.length">
        <button class="btn btn-xs btn-danger" v-on:click="deleteOpenOrders" v-if="selectedShow && !searchStr">{{ purgeText }}</button>
      </div>
    </transition>
  </div>
</template>

<script>
  
import axios from 'axios'
import { DateTime } from 'luxon'
import { TransactionItem } from '#components'
import { mapGetters } from 'vuex'
import errors from '~/lib/errors'
import events from '~/lib/events'
import components from '~/lib/components'

export default {
  data () {
    return {
      shows: [],
      transaction: null,
      items: null,
      limit: 1000,
      start: 0,
      processing: false,
      purgeClicked: false,
      purgeConfirmed: false,
      purgeTimeout: false,
      DateTime: DateTime,
      showSeatPicker: false,
      selectedSeats: [],
      allSeats: [],
      extractionItem: null,
      maxSeats: 1
    }
  },
  mixins: [ components, errors, events ],
  props: ['selectedShow', 'searchStr'],
  computed: {
    ...mapGetters(['allSettings', 'pos', 'clientid', 'basketIds', 'activeBasket']),
    settings () {
      return this.shopSettings(this.shopId)
    },
    data () {
      return JSON.parse(this.component.data)
    },
    purgeText () {
      /* if (this.purgeClicked && this.purgeConfirmed) {
        return this._('Purging...')
      }
      if (this.purgeClicked && !this.purgeConfirmed) {
        return this._('Confirm')
      } */
      return this._('Purge')
    },
    transactions () {
      if (!this.selectedShow) {
        return []
      }
      return this.selectedShow.ownOrder
    }
  },
  methods: {
    setActiveComponent (component) {
      this.$emit('setActiveComponent', component)
    },
    openSeatPicker () {
      this.showSeatPicker = true
    },
    closeSeatPicker () {
      this.showSeatPicker = false
    },
    seatSelected (seatId) {
      this.selectedSeats.push(seatId)
    },
    seatDeselected (seatId) {
      let index = this.selectedSeats.indexOf(seatId)
      if (index !== -1) {
        this.selectedSeats.splice(index, 1)
      }
    },
    seatSelectionCancelled () {
      this.selectedSeats = []
      this.closeSeatPicker()
    },
    async seatSelectionConfirmed () {
      this.closeSeatPicker()
      await this.finishExtraction()
      if (this.selectedSeats.length) {
        this.selectedSeats = []
      }
    },
    async extractTicket (item) {
      this.extractionItem = item
      let response = await axios.get(this.baseDomain + this.shopId + '/orders/' + this.transaction.id + '/items/' + item.item_id + '.json' + '?apikey=' + this.apiKey)
      if (response && response.data && response.data.seats) {
        this.maxSeats = parseInt(item.count, 10)
        this.allSeats = response.data.seats
        this.openSeatPicker()
      }
    },
    async finishExtraction () {
      let basketId = this.basketIds[this.shopId + '-' + this.activeBasket]
      if (!basketId) {
        return
      }
      let data = {
        basket_id: basketId,
        item_id: this.extractionItem.item_id,
        seats: this.selectedSeats.join(','),
        ticketitems: this.extractionItem.id
      }
      await axios.post(this.baseDomain + this.shopId + '/orders/' + this.transaction.id + '/extractor.json?apikey=' + this.apiKey, data)
      this.openTransaction(this.transaction)
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    openTransaction (transaction) {
      this.$emit('openTransaction', transaction)
      //this.$parent.openTransaction(transaction)
    },
    closeTransaction () {
      this.$emit('closeTransaction')
      //this.$parent.closeTransaction()
    },
    displayNotes (transaction) {
      this.EventBus.$emit('displayNotes', {
        type: 'order',
        transaction: transaction
      })
    },
    deleteOpenOrders () {
      const showDetails = DateTime.fromSeconds(Number(this.selectedShow.start_ts), { zone: this.timezone }).toFormat(this.dateFormat + " '" + this._('at') + "' " + this.timeFormat) + ' ' + this.selectedShow.product_name + ' (' + this.selectedShow.resource_name + ')'
      this.showDialog({
        title: this._('Are you sure? All ticket reservations for the selected show deleted permanently.'),
        text: showDetails,
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: this.doDeleteOpenOrders
          }
        ]
      })
    },
    async doDeleteOpenOrders () {
      let show = this.selectedShow
      if (!show || !show.id) {
        return
      }
      try {
        await axios.delete(this.baseDomain + this.shopId + '/shows/' + show.id + '.json?unconfirmed=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
      }
      this.purgeClicked = false
      this.purgeConfirmed = false
      this.$emit('ticketsDeleted')
    }
  },
  components: {
    TransactionItem
  }
}

</script>